import {html} from 'lit';
import {customElement, property} from 'lit/decorators.js';
import B2bElement from '../../b2b-element.js';
import './sso/b2b-public-sso-selection.js'
import ExternalUser from "../../gen/com/arabellesolutions/sdc/b2b/common/user/ExternalUser.js";

@customElement('b2b-public-sso')
export class B2bPublicSso extends B2bElement {
  @property({type: Object, attribute: false})
  accessor route;

  /** @type {ExternalUser} */
  @property({type: ExternalUser, attribute: false})
  accessor user;

  render() {
    return html`
      <mta-page-lit
          .route="${this.route}"
          class="app"
          pattern="/:page/:args"
          @mta-page-title-changed="${this.__titleChanged}"
          .pages="${{ 
            ssoSelection: routeData => html`
              <b2b-public-sso-selection .user="${this.user}" .route="${routeData.data}"></b2b-public-sso-selection>
          `}}">
      </mta-page-lit>
    `;
  }
}
